import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { navItems } from '@/data/navigation';
import Logo from '@/components/Logo';
import styles from './Footer.module.scss';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className={`${styles.footer} dark-section`} id="footer" role="contentinfo">
      <div className="gradient-line"></div>
      <div className="container">
        {/* Main grid */}
        <div className={styles.grid}>
          {/* Brand */}
          <div className={styles.brand}>
            <Logo variant="footer" ariaLabel="Arkatechs" />
            <p className={styles.tagline}>Arkatechs IT Solutions Pvt. Ltd.</p>
            <p className={styles.bio}>
              Technology and digital solutions for businesses worldwide.
            </p>
            {/* Social */}
            <div className={styles.social}>
              <a
                href="https://www.instagram.com/arkatechs/"
                className={styles.socialLink}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <span style={{ fontSize: '18px' }}>📸</span>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Company</h4>
            <ul className={styles.links}>
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className={styles.link}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Services</h4>
            <ul className={styles.links}>
              <li><Link to="/services" className={styles.link}>Web Development</Link></li>
              <li><Link to="/services" className={styles.link}>Mobile App Development</Link></li>
              <li><Link to="/services" className={styles.link}>UI/UX Design</Link></li>
              <li><Link to="/services" className={styles.link}>AI & Automation</Link></li>
              <li><Link to="/services" className={styles.link}>Cloud Solutions</Link></li>

              <li><Link to="/services" className={styles.link}>Digital Marketing</Link></li>
              <li><Link to="/services" className={styles.link}>SEO</Link></li>
              <li><Link to="/services" className={styles.link}>Hosting</Link></li>
              <li><Link to="/services" className={styles.link}>Brand Identity</Link></li>
              <li><Link to="/services" className={styles.link}>UGC Advertisements</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Contact</h4>
            <ul className={styles.links}>
              <li>
                <a href="mailto:arkatechsitsolutions@gmail.com" className={styles.link}>
                  arkatechsitsolutions@gmail.com
                </a>
              </li>
              <li><a href="tel:+917021511094" className={styles.link}>+91 70215 11094</a></li>
              <li><span className={styles.link}>Bhiwandi, Maharashtra, India</span></li>
              <li><span className={styles.link}>Worldwide · Remote-First</span></li>
              <li>
                <a href="https://www.instagram.com/arkatechs/" target="_blank" rel="noopener noreferrer" className={styles.link}>
                  Instagram <ArrowUpRight size={12} style={{ display: 'inline', verticalAlign: 'middle' }} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className={styles.bottom}>
          <span className={styles.copyright}>
            © {year} Arkatechs IT Solutions Pvt. Ltd. All rights reserved.
          </span>
          <span className={styles.credit}>
            Based in India · Working worldwide
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
